// extracted by mini-css-extract-plugin
export default {"swiper":"VerifyDevice_swiper__6AOjO","link_restore":"VerifyDevice_link_restore__WFi7d","verifyWeb":"VerifyDevice_verifyWeb__sG+Kn"};